module.exports = __webpack_public_path__ + "img/PRESONAL STATMENT.497826ee.png";